import React from "react";
import { TextField, FormGroup } from "@material-ui/core";
import RadioBox from "../FormComponents/RadioBox";
import { getIn } from "formik";
import { Number } from "../../utils/Number";

const AutoAccidentInfo = ({ values, touched, handleChange, errors }) => {
  return (
    <div className="auto-accident">
      <div className="row align-items-center">
        <div className="col-lg-12">
          <h5>AUTO ACCIDENT INFORMATION</h5>
        </div>
        <div className="col-md-6 col-lg-4 col-xl-4 auto-info-field">
          <TextField
            label="Number of vehicles involved:"
            name="autoAccident.noOfVehicles"
            fullWidth
            onChange={handleChange}
            value={values.autoAccident.noOfVehicles}
            aria-label="text-field"
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{ maxLength: 3 }}
            error={Boolean(
              getIn(touched, "autoAccident.noOfVehicles") &&
                getIn(errors, "autoAccident.noOfVehicles")
            )}
            helperText={
              getIn(touched, "autoAccident.noOfVehicles") &&
              getIn(errors, "autoAccident.noOfVehicles") &&
              getIn(errors, "autoAccident.noOfVehicles")
            }
            required
            InputProps={{
              inputComponent: Number,
            }}
            // margin="dense"
          />
        </div>
        <div className="form-group col-md-12 col-lg-12 col-xl-8">
          <div className="row align-items-top">
            <div className=" col-md-7 col-lg-auto col-xl-6 radio-btn-alignment">
              <p>
                Were you the driver or a passenger?{" "}
                {getIn(touched, "autoAccident.isDriver") &&
                getIn(errors, "autoAccident.isDriver") ? (
                  <span style={{ color: "red" }}>{`*`}</span>
                ) : (
                  "*"
                )}
              </p>
            </div>
            <div className=" col-md-5 col-lg-6 col-xl-6 custom-legend">
              <FormGroup>
                <RadioBox
                  name="autoAccident.isDriver"
                  value={values.autoAccident.isDriver}
                  label={["Driver", "Passenger"]}
                  handleChange={handleChange}
                  helperText={
                    getIn(touched, "autoAccident.isDriver") &&
                    getIn(errors, "autoAccident.isDriver") &&
                    getIn(errors, "autoAccident.isDriver")
                  }
                  required={true}
                />
              </FormGroup>
            </div>
          </div>
        </div>
        <div className=" form-group col-md-6 col-lg-4 col-xl-4 auto-break text-space">
          <TextField
            label="Who was responsible for the accident?"
            name="autoAccident.responsiblePerson"
            fullWidth
            onChange={handleChange}
            value={values.autoAccident.responsiblePerson}
            aria-label="text-field"
            InputLabelProps={{
              shrink: true,
            }}
            error={Boolean(
              getIn(touched, "autoAccident.responsiblePerson") &&
                getIn(errors, "autoAccident.responsiblePerson")
            )}
            helperText={
              getIn(touched, "autoAccident.responsiblePerson") &&
              getIn(errors, "autoAccident.responsiblePerson") &&
              getIn(errors, "autoAccident.responsiblePerson")
            }
            required
            inputProps={{ maxLength: 50 }}
            // margin="dense"
          />
        </div>
      </div>
    </div>
  );
};

export default AutoAccidentInfo;
